import { ClipboardModule } from '@angular/cdk/clipboard';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MaterialAngularModule } from './../material-design/material.module';
import { BanqiComponent } from './banqi/banqi.component';
import { BoletoParcelaComponent } from './boleto-parcela/boleto-parcela.component';
import { ConfirmaRenegociacaoModalComponent } from './confirma-renegociacao-modal/confirma-renegociacao-modal.component';
import { ContratoPageComponent } from './contrato-page/contrato-page.component';
import { ContratoService } from './contrato.service';
import { ListaParcelasComponent } from './lista-parcelas/lista-parcelas.component';
import { PlanoCardComponent } from './plano-card/plano-card.component';
import { PlanoMassivoCardComponent } from './plano-massivo-card/plano-massivo-card.component';
import { RenegocicaoPageComponent } from './renegocicao-page/renegocicao-page.component';
import { SegundaViaParcelaPageComponent } from './segunda-via-parcela-page/segunda-via-parcela-page.component';
import { SegundaViaComponent } from './segunda-via/segunda-via.component';
import { SituacaoContratoPipe } from './situacao-contrato.pipe';
import { StatusParcelaTextPipe } from './status-parcela-text.pipe';
import { StatusParcelaPipe } from './status-parcela.pipe';
import { EnviaLinhaDigitavelModalComponent } from './boleto-parcela/envia-linha-digitavel-modal/envia-linha-digitavel-modal.component';
import { RenegociacaoPlanosParcelamentoComponent } from './renegociacao-planos-parcelamento/renegociacao-planos-parcelamento.component';
import { PropostasOutrosCanaisModalComponent } from './propostas-outros-canais-modal/propostas-outros-canais-modal.component';
import { CanaisPropostasPipe } from './canais-propostas.pipe';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { NovoPlanoCardComponent } from './renegocicao-page/novo-plano-card/novo-plano-card.component';
import { PlanoEfetivadoCardComponent } from './renegocicao-page/plano-efetivado-card/plano-efetivado-card.component';
import { ContratoTableComponent } from './renegocicao-page/contrato-table/contrato-table.component';
import { ComponentsModule } from '../shared/components/components.module';
import { StatusPagamentoCelerPipe } from './status-pagamento-celer.pipe';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialAngularModule,
    ClipboardModule,
    FlexLayoutModule,
    CurrencyMaskModule,
    SharedDirectivesModule,
    ComponentsModule,
    RouterModule,
  ],
  declarations: [
    StatusParcelaTextPipe,
    StatusParcelaPipe,
    SituacaoContratoPipe,
    ContratoPageComponent,
    ListaParcelasComponent,
    SegundaViaParcelaPageComponent,
    SegundaViaComponent,
    RenegocicaoPageComponent,
    PlanoCardComponent,
    NovoPlanoCardComponent,
    BoletoParcelaComponent,
    BanqiComponent,
    ConfirmaRenegociacaoModalComponent,
    PlanoMassivoCardComponent,
    EnviaLinhaDigitavelModalComponent,
    RenegociacaoPlanosParcelamentoComponent,
    PropostasOutrosCanaisModalComponent,
    CanaisPropostasPipe,
    PlanoEfetivadoCardComponent,
    ContratoTableComponent,
    StatusPagamentoCelerPipe,
  ],
  exports: [
    ContratoPageComponent,
    SegundaViaParcelaPageComponent,
    SegundaViaComponent
  ],
  providers: [
    CurrencyPipe,
    ContratoService,
    StatusParcelaTextPipe,
    SituacaoContratoPipe,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
  ]
})
export class ContratoModule { }
